<nav class="sidebar" [ngClass]="{sidebarPushRight: isActive}">
	<ul class="list-group">
		<a [routerLink]="['/layout/dashboard']" [routerLinkActive]="['router-link-active']" class="list-group-item">
			<em class="fa fa-fw fa-dashboard"></em>Dashboard
		</a>
		<a [routerLink]="['/layout/applications']" [routerLinkActive]="['router-link-active']" class="list-group-item">
			<em class="fa fa-database"></em>Applications
		</a>
		<a [routerLink]="['/layout/loginlog/successful']" [routerLinkActive]="['router-link-active']" class="list-group-item">
			<em class="fa fa-fw fa-bar-chart-o"></em>Statistics
		</a>
		<a [routerLink]="['/layout/audit']" [routerLinkActive]="['router-link-active']" class="list-group-item"> <em
				class="fa fa-book"></em>Logs
		</a>
	</ul>
</nav>